export const alfaNumeric = /^[a-zA-Z0-9 ]+$/;
export const alfaNumericWithoutSpace = /^[a-zA-Z0-9]+$/;
export const alfaString = /^[a-zA-Z ]+$/;
export const onlyNumber = /^[0-9]+$/;
export const invRejex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Z\d!@#$%^&*]{8,}$/
export const chequeNumberRE = /^\d{6}$/;

export const NumSixAndTwo = /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/;
export const NumSixAndFour = /^(0|[1-9]\d{0,6})(\.\d{0,4})?$/;
